import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
import CVDescription from '../../element/CVDescription';
// helpers
import { resultInfo } from '../../helpers';
// hooks
import { useWindowSize } from '../../../Hooks/use-window-size';
// mui
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import CreateIcon from '@mui/icons-material/Create';
// import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Modal } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
// settings
import { blockReasons, warningReasons } from './settings';

const APResumeView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cvDetails, setCvDetails] = useState({});
  const [selectedBlockReasons, setSelectedBlockReasons] = useState([]);
  const [selectedWarningReasons, setSelectedWarningReasons] = useState([]);

  const { status, position, resume_verified } = cvDetails;

  const handleCheckboxChange = (reason, type) => {
    const selectedReasons = type === 'block' ? selectedBlockReasons : selectedWarningReasons;
    const setSelectedReasons = type === 'block' ? setSelectedBlockReasons : setSelectedWarningReasons;

    if (selectedReasons.includes(reason)) {
      setSelectedReasons(selectedReasons.filter(r => r !== reason));
    } else {
      setSelectedReasons([...selectedReasons, reason]);
    }
  };

  const isBlockButtonActive = selectedBlockReasons.length > 0 || selectedWarningReasons.length > 0;
  const isPublishButtonActive = selectedBlockReasons.length === 0 && selectedWarningReasons.length === 0;

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + '/admin/resumes/show',
        { id },
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setCvDetails(response.data.response);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Jobs List', error);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleActivate = async id => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Activate Resume?',
        text: 'Do you want to Activate this Resume?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/resumes/admin_activate/${id}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          resultInfo('success', 'Resume Activated successfully!', 'Close');
        } else {
          resultInfo('error', response.data.message, 'Close');
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Activate Resume',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t activate the record!', error.message);
    }
  };

  const handleDeactivate = async id => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Deactivate Resume',
        text: 'Do you want to Deactivate this Resume?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/resumes/admin_deactivate/${id}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          resultInfo('success', 'Resume Deactivated successfully!', 'Close');
        } else {
          resultInfo('error', response.data.message, 'Close');
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Deactivate Resume',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t deactivate the record!', error.message);
    }
  };

  // const handleDelete = async slug => {
  //   try {
  //     const confirmationResult = await Swal.fire({
  //       icon: 'question',
  //       title: 'Delete Job?',
  //       cancelButtonText: 'No',
  //       showCancelButton: true,
  //       confirmButtonText: 'Yes',
  //       text: 'Do you want to Delete this Job?',
  //     });

  //     if (confirmationResult.isConfirmed) {
  //       const response = await axios.post(
  //         BaseApi + `/admin/job/admin_delete/${slug}`,
  //         null,
  //         {
  //           headers: {
  //             key: ApiKey,
  //             token: tokenKey,
  //             adminid: adminID,
  //             'Content-Type': 'application/json',
  //           },
  //         },
  //       );

  //       if (response.data.status === 200) {
  //         resultInfo('success', 'Job deleted successfully!', 'Close');
  //       } else {
  //         resultInfo('error', response.data.message, 'Close');
  //       }

  //       getData();
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       icon: 'error',
  //       confirmButtonText: 'Close',
  //       text: 'Could not Delete job',
  //       title: 'Failed. Please try after some time!',
  //     });

  //     console.error('Couldn\'t delete the record!', error.message);
  //   }
  // };

  const handleVerify = async id => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        title: 'Verify Resume?',
        confirmButtonText: 'Yes',
        text: 'Do you want to Verify this Resume?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/resumes/verify/${id}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          resultInfo('success', 'Resume verified successfully!', 'Close');
        } else {
          resultInfo('error', response.data.message, 'Close');
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Verify Resume',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t verify the record!', error.message);
    }
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); //eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic APManageSubadmin'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb1' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      color='inherit'
                      underline='hover'
                      to={'/admin/admins/dashboard'}
                    >
                      Dashboard
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      to={'/admin/resumes'}
                    >
                      Resumes
                    </Link>
                    <Typography color='text.primary'>Resume {position?.label}</Typography>
                  </Breadcrumbs>
                </div>
                <div className='container my-5 JSMyCV'>
                  <div className='row'>
                    <div className='col cheaps'>
                      <button className='btn btn-primary button2' onClick={() => navigate('/admin/resumes')}>
                        <ChevronLeftOutlinedIcon />
                        {' '}
                        {width >= 768 && 'Back'}
                      </button>
                      {
                        status === 1
                          ? (
                            <button
                              disabled
                              type='button'
                              onClick={() => handleOpen()}
                              className='btn btn-primary button1 activated'
                            >
                              <CheckIcon />
                              {' '}
                              {width >= 768 && 'Deactivate'}
                            </button>
                          )
                          : (
                            <button
                              disabled
                              type='button'
                              onClick={() => handleOpen()}
                              className='btn btn-primary button1'
                            >
                              <BlockIcon />
                              {' '}
                              {width >= 768 && 'Activate'}
                            </button>
                          )
                      }
                      <button className='btn btn-primary button1' onClick={() => navigate(`/admin/resumes/editResume/${id}`)}>
                        <CreateIcon />
                        {' '}
                        {width >= 768 && 'Edit'}
                      </button>
                      {
                        !resume_verified && (
                          <button className='btn btn-primary button1' onClick={() => handleVerify(id)}>
                            <VerifiedIcon />
                            {' '}
                            {width >= 768 && 'Verify Now'}
                          </button>
                        )
                      }
                    </div>
                  </div>
                  <CVDescription cvDetails={cvDetails} />
                </div>
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby='modal-modal-title'
                  className='modalMain APResumeListModal'
                  aria-describedby='modal-modal-description'
                >
                  <Box
                    className='modal adminModal modal-content'
                    sx={{ width: '100%', maxWidth: '343px', maxHeight: 'fit-content' }}
                  >
                    <IconButton
                      onClick={handleClose}
                      className='close-button'
                      style={{ top: 10, right: 10, position: 'absolute' }}
                    >
                      &times;
                    </IconButton>
                    <Box
                      sx={{ mt: 3 }}
                      id='modal-modal-description'
                    >
                      <div>
                        <div className='blocksBox'>
                          <h2>Блокувати через:</h2>
                          {
                            blockReasons.map((reason, index) => (
                              <label key={index}>
                                <input
                                  type='checkbox'
                                  checked={selectedBlockReasons.includes(reason)}
                                  onChange={() => handleCheckboxChange(reason, 'block')}
                                />
                                {reason}
                              </label>
                            ))
                          }
                        </div>
                        <div className='warningsBox'>
                          <h2>Попередити про:</h2>
                          {
                            warningReasons.map((reason, index) => (
                              <label key={index}>
                                <input
                                  type='checkbox'
                                  checked={selectedWarningReasons.includes(reason)}
                                  onChange={() => handleCheckboxChange(reason, 'warning')}
                                />
                                {reason}
                              </label>
                            ))
                          }
                        </div>
                        <div className='buttons'>
                          <button
                            disabled={!isPublishButtonActive}
                            onClick={() => handleActivate(id)}
                            className='btn-secondary activated'
                          >
                            <CheckIcon /> Активувати
                          </button>
                          <button
                            className='btn-secondary'
                            disabled={!isBlockButtonActive}
                            onClick={() => handleDeactivate(id)}
                          >
                            <BlockIcon /> Блокувати
                          </button>
                        </div>
                      </div>
                    </Box>
                  </Box>
                </Modal>
              </div>
            )}
      </div>
    </>
  );
};

export default APResumeView;
